import { Link } from '../../schema/prismic/fields/link';
import { RichTextFormat } from '../../schema/prismic/fields/text';
import { Slice } from '../slice';

export enum LaPosteEn4Type {
  HEADER = 'header',
  PROOF_CATEGORY = 'proof_category',
  DISCLAIMER = 'disclaimer',
  FOOTNOTES = 'footnotes',
}

export type HeaderSlice = Slice & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image: any;
  description: RichTextFormat[];
  ctaLabel: string;
  ctaLink: Link;
};
export type ProofCategorySlice = Slice & {
  title: string;
  theme: string;
  items: {
    icon: string;
    title: string;
    description: RichTextFormat[];
    ctaLabel?: string;
    ctaLink?: Link;
  }[];
};
export type DisclaimerSlice = Slice & {
  description: RichTextFormat[];
};
export type FootnotesSlice = Slice & {
  notes: {
    reference: string;
    description: string;
  }[];
};
